module.exports = __webpack_public_path__ + "img/driving-lessons.7d8c94f7.webp";